import { Lock } from 'lucide-react'
import { RequirePermission } from '../../shared/components/RequirePermission'
import { JOBAUTO_USE } from '../people-space/permissions'

/**
 * Route guard for the JobAuto Rechner.
 *
 * It used to compare the signed-in email against four hard-coded names, which only hid the page:
 * the proxy accepted any @finn.com token. Both sides now use one RBAC permission (PLA-626), and
 * the proxy enforces it with `alwaysEnforce` on all of `/api/jobauto`. `strict` keeps the two in
 * step — the default guard would defer to the audit-only flag and render the page for colleagues
 * the API then answers 403 to.
 */
function JobAutoRestricted() {
  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center p-6">
      <div className="bg-white border border-zinc-200 rounded-xl shadow-sm p-8 max-w-sm w-full text-center space-y-4">
        <div className="w-12 h-12 bg-zinc-100 rounded-full flex items-center justify-center mx-auto">
          <Lock className="h-6 w-6 text-zinc-400" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-zinc-900">Kein Zugriff</h2>
          <p className="text-sm text-zinc-500 mt-1">
            Du hast keine Berechtigung für den JobAuto Gehaltscheck.
            Wende dich an das People-Ops Team.
          </p>
        </div>
      </div>
    </div>
  )
}

export default function JobAutoGuard({ children }: { children: React.ReactNode }) {
  return (
    <RequirePermission strict permission={JOBAUTO_USE} fallback={<JobAutoRestricted />}>
      {children}
    </RequirePermission>
  )
}
